type Props = {
  color?: string;
  isActive?: boolean;
  isRotated?: boolean;
};

const SortArrowIcon = ({ color = '#9CA3AF', isActive = false, isRotated = false }: Props) => (
  <svg
    width='8'
    height='6'
    viewBox='0 0 8 6'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    { ...(isRotated ? { transform: 'rotate(180)' } : {}) }
  >
    <path
      d='M1.26439 4.96905C0.975205 5.04097 0.656454 5.12089 0.404235 4.96219C0.0288909 4.72601 -0.112022 4.19134 0.195134
  3.79203L3.37835 0.562776C3.69938 0.145431 4.32867 0.145431 4.64971 0.562776L7.83292 3.79203C8.14008 4.19133 7.99917
  4.72601 7.62382 4.96219C7.3716 5.12089 7.05285 5.04097 6.76366 4.96905C6.13233 4.81203 4.93498 4.54835 4.01403
  4.54835C3.09308 4.54835 1.89573 4.81203 1.26439 4.96905Z'
      fill={ isActive ? '#111827' : color }
    />
  </svg>
);

export default SortArrowIcon;
